import React, { useState, useEffect } from 'react';

import { Row, Col, Typography, Modal, Input, message, Checkbox } from 'antd';
import { DndContext, closestCenter, useSensors, useSensor, PointerSensor } from '@dnd-kit/core';
import { SortableContext, useSortable, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import PdButton from 'components/pd-button';
import { get } from 'lodash';

import ProductService from 'services/product';

import './style.scss';

const { Title } = Typography;
const { Search } = Input;

export default function ProductSize({
  data,
  dataModifier,
  productDetail,
  dataModifiedIndicator,
}) {
  const [modalVisible, setModalVisible] = useState(false);
  const [modalValue, setModalValue] = useState([]);
  const [modalTitle, setModalTitle] = useState('');
  const [sizeProduct, setSizeProduct] = useState({});
  const [modalProduct, setModalProduct] = useState(false);
  const [allProducts, setAllProducts] = useState([]);
  const [productNextPage, setProductNextPage] = useState(1);
  const [searchValue, setSearchValue] = useState('');
  const [page, setPage] = useState(1);

  async function fetchAllProduct(
    page = 1,
    q = '',
    loadmore,
    total = 4,
    sort_by = 'created_at desc'
  ) {
    try {
      const { data } = await ProductService.getProductList({
        page,
        q,
        sort_by,
        total,
      });
      const productData = data.data;
      const metadata = data.metadata;

      const newProduct = productData.map((product) => {
        if (Number(product.id) === Number(sizeProduct.id)) {
          product.checked = true;
        } else {
          product.checked = false;
        }
        return product;
      });

      const filterProduct = newProduct.filter(
        (product) => product.id !== productDetail.id
      );

      setProductNextPage(metadata.next_cursor);
      if (loadmore) {
        setAllProducts((prevstate) => [...prevstate, ...filterProduct]);
      } else {
        setAllProducts(filterProduct);
      }
    } catch (err) {
      if (err.response.data.message) {
        const errMessage = err.response.data.message;
        message.error(errMessage);
      } else {
        message.error('Tidak dapat menghubungi server, cek koneksi');
      }
    }
  }

  function searchOnClick() {
    fetchAllProduct(1, searchValue);
  }

  function changePage(page) {
    setPage(page);
    fetchAllProduct(page, searchValue, true);
  }

  function showSelectProduct(index, id) {
    setSizeProduct({
      sizeIndex: index,
      id: id,
    });
    setModalProduct(true);
  }

  useEffect(() => {
    if (sizeProduct.id !== undefined) {
      fetchAllProduct();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sizeProduct]);

  function selectProduct(value) {
    const sizeList = [...modalValue];
    const newSizeList = sizeList.map((size, i) => {
      if (i === sizeProduct.sizeIndex) {
        return {
          ...size,
          product_id: value.id,
          product: value,
        };
      } else {
        return size;
      }
    });
    setModalValue(newSizeList);
    setModalProduct(false);
    setAllProducts([]);
    setSizeProduct({});
    setPage(1);
  }

  function closeModalProduct() {
    setAllProducts([]);
    setModalProduct(false);
    setSizeProduct({});
    setPage(1);
  }

  function showModal(title) {
    const newValue = data.map((data) => ({ ...data }));
    if (newValue[0] === undefined) {
      newValue[0] = {
        order_level: 1,
        product: productDetail,
        product_id: productDetail.id,
        size: '',
      };
    }
    setModalValue(newValue);
    setModalVisible(true);
    setModalTitle(`${title} Size`);
  }

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        delay: 200,
        tolerance: 5,
      },
    })
  );

  function SortableItem({ value }) {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
      id: value.id || data.indexOf(value),
    });

    const style = {
      transform: CSS.Transform.toString(transform),
      transition,
      opacity: isDragging ? 0.5 : 1,
      userSelect: 'none',
    };

    return (
      <div
        ref={setNodeRef}
        style={{...style, display: value._destroy ? 'none' : 'block'}}
        className="draggable-item"
        {...attributes}
        {...listeners}>
        <Row gutter={20}>
          <Col span={6} className="draggable draggable-content size-list">
            <span className="fs-16">{value.size}</span>
          </Col>
          <Col span={18} className="draggable draggable-content size-list">
            <span className="fs-16">{get(value, 'product.title', '')}</span>
          </Col>
        </Row>
      </div>
    );
  }

  function handleDragEnd(event) {
    const { active, over } = event;
    if (active && over && active.id !== over.id) {
      const oldIndex = data.findIndex((item, index) => (item.id || index) === active.id);
      const newIndex = data.findIndex((item, index) => (item.id || index) === over.id);

      let list = [...data];
      let temp = list[oldIndex];
      list.splice(oldIndex, 1);
      list.splice(newIndex, 0, temp);
      list.forEach((item, index) => {
        list[index] = {
          ...item,
          order_level: index + 1,
        };
      });
      dataModifier((prevState) => ({
        ...prevState,
        sizes: list,
      }));
      dataModifiedIndicator(true);
    }
  }

  function onOk() {
    let list = [...modalValue];
    let emptySize = false;
    let emptyProduct = false;

    list.forEach((x) => {
      if (!x._destroy) {
        if (x.size === '') {
          emptySize = true;
        }
        if (x.product_id === null) {
          emptyProduct = true;
        }
      }
    });

    if (!emptySize) {
      if (!emptyProduct) {
        dataModifier((prevState) => ({
          ...prevState,
          sizes: list,
        }));
        dataModifiedIndicator(true);
        setModalValue([]);
        setModalVisible(false);
      } else {
        message.error('please select a product!');
      }
    } else {
      message.error("size can't be empty!");
    }
  }

  function onChangeSize(value, index) {
    const newData = [...modalValue];
    if (index === 0) {
      const obj = { ...newData[index], size: value };
      newData[index] = obj;
    } else {
      newData[index]['size'] = value;
    }
    setModalValue(newData);
  }

  function onCancel() {
    setModalVisible(false);
    setModalValue([]);
  }

  function addSizeModal() {
    const list = [...modalValue];
    list.push({
      size: '',
      product_id: null,
      product: {},
      _destroy: false,
    });
    setModalValue(list);
  }

  function deleteSizeModal(index) {
    const newData = [...modalValue];
    newData[index]['_destroy'] = true;
    setModalValue(newData);
  }

  return (
    <div className="section-container product-size">
      <div className="inner-section">
        <Title className="pageSubtitle" level={3}>
          Size
        </Title>
        <div className="buttonSection">
          <PdButton
            type="primary"
            full
            outline
            onClick={() => showModal('Edit')}>
            Edit Size
          </PdButton>
        </div>
        <div id="drag-content-size">
          {data.filter((x) => !x._destroy).length === 0 && (
            <div className="no-color">No sizing added yet</div>
          )}
          <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
            <SortableContext items={data.map((item, index) => ({ id: item.id || index }))} strategy={verticalListSortingStrategy}>
              {data.map((item, index) => (
                <SortableItem
                  key={item.id || index}
                  value={item}
                />
              ))}
            </SortableContext>
          </DndContext>
        </div>
      </div>
      <Modal
        title={modalTitle}
        open={modalVisible}
        onCancel={onCancel}
        className="modal-size"
        onOk={onOk}>
        <Row gutter={[20, 20]}>
          {modalValue.map((size, i) =>
            size.product_id === productDetail.id ? (
              <Col key={i} span={24}>
                <Row gutter={20} className="size-container">
                  <Col span={5}>
                    <Input
                      value={get(size, 'size', '')}
                      onChange={(e) => onChangeSize(e.target.value, 0)}
                    />
                  </Col>
                  <Col span={8} className="size-product">
                    <span>{get(size, 'product.title', '')}</span>
                  </Col>
                </Row>
              </Col>
            ) : (
              <Col
                key={i}
                span={24}
                style={{ display: size._destroy && 'none' }}>
                <Row gutter={20} className="size-container">
                  <Col span={5}>
                    <Input
                      value={size.size}
                      onChange={(e) => onChangeSize(e.target.value, i)}
                    />
                  </Col>
                  {size.product_id !== null && (
                    <>
                      <Col span={8} className="size-product">
                        <span>{get(size, 'product.title', '')}</span>
                      </Col>
                      <Col span={7} className="size-product">
                        <PdButton
                          type="primary"
                          full
                          outline
                          onClick={() => showSelectProduct(i, size.product_id)}>
                          Change Product
                        </PdButton>
                      </Col>
                    </>
                  )}
                  {size.product_id === null && (
                    <>
                      <Col span={7} className="size-product">
                        <PdButton
                          type="primary"
                          full
                          outline
                          onClick={() => showSelectProduct(i, size.product_id)}>
                          Select Product
                        </PdButton>
                      </Col>
                      <Col span={8} className="size-product">
                        <div className="invisible"></div>
                      </Col>
                    </>
                  )}
                  <Col span={3} className="size-product">
                    <PdButton
                      type="danger"
                      full
                      onClick={() => deleteSizeModal(i)}>
                      Delete
                    </PdButton>
                  </Col>
                </Row>
              </Col>
            )
          )}
          <Col span={24}>
            <PdButton type="primary" full outline onClick={addSizeModal}>
              Add Sizing
            </PdButton>
          </Col>
        </Row>
      </Modal>
      <Modal
        title="Select Product"
        className="modal--productSizeList"
        open={modalProduct}
        onOk={() => setModalProduct(false)}
        onCancel={closeModalProduct}>
        <div className="modal-container">
          <Row>
            <Col span={24}>
              <Search
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                enterButton
                className="search-product"
                placeholder="Search Product List"
                onSearch={searchOnClick}
              />
            </Col>
            <Col span={24} className="product-catalog">
              {allProducts.map((product, i) => (
                <Row key={i} className="product-item">
                  <Col span={1}>
                    <Checkbox
                      checked={product.checked}
                      onChange={() => selectProduct(product)}
                    />
                  </Col>
                  <Col span={23} className="product-title">
                    <span className="bold">{product.title}</span>
                  </Col>
                </Row>
              ))}
              <Row>
                <Col span={8} offset={8}>
                  <div className="center-button">
                    {productNextPage !== -1 && (
                      <PdButton
                        type="primary"
                        outline
                        style={{ height: 32 }}
                        onClick={() => changePage(Number(page) + 1)}>
                        Load More
                      </PdButton>
                    )}
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </Modal>
    </div>
  );
}
